<template>
  <main>
    <!-- table -->
    <v-data-table
      :headers="headers"
      :items="items"
      hide-default-footer
      :items-per-page="20"
      :loading="tableLoading"
      class="table"
    >
      <template v-slot:item="{ item, index }">
        <tr>
          <slot :item="item" :index="index"></slot>
        </tr>
      </template>
    </v-data-table>
    <!-- table -->
    <!-- dialog -->
    <v-dialog max-width="800" v-model="dialog">
      <v-card>
        <slot :dialog="dialog" name="wrraping_dialog"> </slot>
      </v-card>
    </v-dialog>
    <!-- dialog -->
    <!-- pagination -->
    <div class="text-xs-center mt-4">
      <v-pagination
        v-if="items.length > 0 && pagination.last_page > 1"
        v-model="pagination.current_page"
        :length="pagination.last_page"
        :total-visible="10"
        @input="handlePagination"
      ></v-pagination>
    </div>
    <!-- pagination -->
    <!-- Image Preview -->
    <global-image-preview
      :showDialog="overlay"
      :imagePath="imagePath"
      @closePreview="overlay = false"
    />
    <!-- Image Preview -->
  </main>
</template>

<script>
import TableHeaders from "@/helpers/TableHeaders";
import {
  IndexData,
  DeleteData,
  StoreData,
  UpdateData,
} from "@/helpers/apiMethods";
import { isEqual } from "lodash";

export default {
  name: "WrappingTable",
  inheritAttrs: false,
  props: {
    pathName: {
      type: String,
      required: true,
    },
    headersName: {
      type: Array,
      required: true,
    },
    dataName: {
      type: String,
      default: "",
    },
    dialogWidth: {
      type: String,
      default: "900",
    },
    imagePath: {
      type: String,
      default: "",
    },
    customQuery: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      items: [],
      headers: [],
      tableLoading: true,
      pagination: {},
      queries: {},
      dialog: false,
      overlay: false,
    };
  },
  mounted() {
    this.createTableHeaders();
  },
  methods: {
    // getItems() {
    //   if (this.items) {
    //     return this.items;
    //   }
    // },
    handleOnCreate(reqName, data, responseName) {
      return new Promise(async (reselove, reject) => {
        try {
          const res = await StoreData({ reqName, data });
          const item = res.data[responseName];
          this.items.push(item);
          this.dialog = false;
          reselove(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    handleOnEdit(reqName, data, param, responseName, index) {
      return new Promise(async (reselove, reject) => {
        try {
          const res = await UpdateData({ reqName, data, param });
          const item = res.data[responseName];
          this.$set(this.items, index, item);
          this.dialog = false;
          reselove(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    toggleDialog() {
      this.dialog = !this.dialog;
    },
    createTableHeaders() {
      this.headers = TableHeaders(this.headersName);
    },
    handleGetItems(query) {
      IndexData({ reqName: this.pathName, query })
        .then((res) => {
          const { meta, data } = res.data;

          this.items = data;
          this.pagination = meta;
          if (data) {
            this.$emit("get_items", data);
          }
        })
        .catch((err) => console.log(err))
        .finally(() => (this.tableLoading = false));
    },
    handlePagination(page) {
      this.queries = { ...this.queries, page };
      if (!isEqual(this.queries, this.$route.query)) {
        this.$router.push({ query: this.queries });
      }
    },
    handleDelete(param, index) {
      this.popUp().then((value) => {
        if (!value.dismiss) {
          DeleteData({ reqName: this.pathName, param })
            .then(() => {
              this.$delete(this.items, index);
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },
    handleUpdateItems(data, index) {
      this.$set(this.items, index, data);
    },
  },
  watch: {
    $route: {
      handler({ query }) {
        const newQuery = { ...query, ...this.customQuery };
        this.queries = newQuery;
        this.handleGetItems(this.queries);
      },
      immediate: true,
    },
    items: {
      handler(val) {
        const { current_page } = this.pagination;
        if (
          val.length > this.pagination.per_page &&
          this.$route.query.page > 1
        ) {
          this.$router.push({
            query: {
              page: current_page - 1,
            },
          });
        }
        if (
          val.length > this.pagination.per_page &&
          this.$route.query.page >= 1
        ) {
          this.$router.push({
            query: {
              page: current_page + 1,
            },
          });
        }
      },
      immediate: true,
    },
    dialog: {
      handler(value) {
        if (!value) {
          this.$emit("on_dialog_close");
          this.$store.dispatch("ClearServerErrors");
        }
      },
      immediate: false,
    },
  },
};
</script>
